import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { defaultHomeSettings, normalizeHomeSettings } from "../utils/homeContent";
import { RUNTIME_PUBLIC_BASE } from "../utils/runtimeBase";

function Hero({ settings, banners }) {
  const navigate = useNavigate();
  const [images, setImages] = useState([]);
  const [current, setCurrent] = useState(0);
  const homeSettings = normalizeHomeSettings(settings || defaultHomeSettings);
  const showHeroContent = homeSettings.hero_content_visible !== false;

  useEffect(() => {
    const data = Array.isArray(banners) ? banners : [];
    const urls = data
      .map((item) => item?.image)
      .filter(Boolean)
      .map((image) => `${RUNTIME_PUBLIC_BASE}/uploads/${image}`);

    setImages(urls);
  }, [banners]);

  useEffect(() => {
    if (images.length === 0) return undefined;

    const interval = window.setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 4000);

    return () => window.clearInterval(interval);
  }, [images]);

  return (
    <section className="hero-modern">
      <div className="hero-modern__bg">
        {images.length > 0 ? (
          images.map((img, index) => (
            <img
              key={img}
              src={img}
              alt="NIDCS banner"
              className="hero-modern__image"
              loading="eager"
              fetchPriority="high"
              decoding="async"
              data-eager-media="true"
              style={{
                opacity: index === current ? 1 : 0,
              }}
            />
          ))
        ) : (
          <div className="hero-modern__fallback" />
        )}
      </div>

      <div
        className="hero-modern__overlay"
        style={{ opacity: showHeroContent ? 1 : 0.38 }}
      />

      {showHeroContent ? (
        <div className="hero-modern__content">
          {homeSettings.subtitle ? <div className="hero-modern__eyebrow">{homeSettings.subtitle}</div> : null}
          <h2>{homeSettings.title}</h2>
          <p>{homeSettings.description}</p>

          <div className="hero-modern__actions">
            <button
              type="button"
              className="hero-modern__button hero-modern__button--primary"
              onClick={() => navigate(homeSettings.hero_primary_button_link || "/franchise-apply")}
            >
              {homeSettings.hero_primary_button_text || "Apply For Franchise"}
            </button>
            <button
              type="button"
              className="hero-modern__button hero-modern__button--secondary"
              onClick={() => navigate(homeSettings.hero_secondary_button_link || "/student-registration")}
            >
              {homeSettings.hero_secondary_button_text || "Student Registration"}
            </button>
          </div>
        </div>
      ) : null}
    </section>
  );
}

export default Hero;
